/** 统计图表 echarts theme mode 适配 */

export function withCartesianAxisTheme(axisConfig, token) {
    const axisLabelColor = token.colorTextSecondary;
    const lineColor = token.colorSplit;

    return {
        ...axisConfig,
        axisLabel: {
            ...axisConfig?.axisLabel,
            color: axisLabelColor,
        },
        axisLine: {
            lineStyle: {
                color: lineColor,
            },
        },
        splitLine: {
            lineStyle: {
                color: lineColor,
            },
        },
    };
}

export function withTooltipTheme(tooltip, token) {
    if (!tooltip) {
        return tooltip;
    }

    return {
        ...tooltip,
        backgroundColor: token.colorBgElevated,
        borderColor: token.colorBorderSecondary,
        textStyle: {
            color: token.colorText,
        },
    };
}

export function withSeriesLabelTheme(series, token) {
    if (!Array.isArray(series)) {
        return series;
    }

    return series.map(item => {
        if (!item.label) {
            return item;
        }

        if (item.label.normal) {
            return {
                ...item,
                label: {
                    ...item.label,
                    normal: {
                        ...item.label.normal,
                        color: token.colorText,
                    },
                },
            };
        }

        return {
            ...item,
            label: {
                ...item.label,
                color: token.colorText,
                textStyle: {
                    ...item.label.textStyle,
                    color: token.colorText,
                },
            },
        };
    });
}

export function buildCartesianChartOptions({ xAxis, yAxis, series, tooltip, token }) {
    return {
        tooltip: withTooltipTheme(tooltip, token),
        xAxis: withCartesianAxisTheme(xAxis, token),
        yAxis: withCartesianAxisTheme(yAxis, token),
        series: withSeriesLabelTheme(series, token),
    };
}
